import _ from 'lodash';

export default function findIndex(items, key, field) {
  if (field) {
    const index = _.findIndex(items, (item) => item[field] === key);
    return index;
  }

  const index = _.findIndex(items, (item) => item.type === key);
  return index;
}
